import accountReducers from './account';
import authReducers from './auth';
import baggageReducers from './baggage';
import claimsReducers from './claims';
import collectiblesEndorsementsReducers from './collectiblesEndorsements';
import rentalCarExtensionsReducers from './rentalCarExtensions';
import miscReducers from './misc';
import policiesReducers from './policies';
import { rentersReducers } from 'shared/lib/apps/RentersApp/reducers';
import { bopReducers } from 'shared/lib/apps/BopApp/reducers';
import { collectiblesReducers } from 'shared/lib/apps/CollectiblesApp/reducers';
import { rentalCarReducers } from 'shared/lib/apps/RentalCarApp/reducers';

const reducers = {
  ...accountReducers,
  ...authReducers,
  ...baggageReducers,
  ...bopReducers,
  ...claimsReducers,
  ...collectiblesEndorsementsReducers,
  ...rentalCarExtensionsReducers,
  ...collectiblesReducers,
  ...miscReducers,
  ...policiesReducers,
  ...rentalCarReducers,
  ...rentersReducers,
};

export default reducers;
